import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { 
  Users, Building2, Stethoscope, Lock,
  Activity, ChevronRight, Shield, Database, TrendingUp, MapPin
} from 'lucide-react';
import { Badge } from '../../components/ui/badge';
import { useAuth } from '../../contexts/AuthContext';
import Navbar from '../../components/Navbar';

export default function AdminDashboard() {
  const { api } = useAuth();
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchStats();
  }, []);

  const fetchStats = async () => {
    try {
      const response = await api.get('/admin/stats');
      setStats(response.data);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const StatCard = ({ icon: Icon, label, value, color = 'primary' }) => (
    <div className="bg-white rounded-2xl border border-slate-100 p-6">
      <div className="flex items-center justify-between mb-4">
        <div className={`w-12 h-12 bg-${color}/10 rounded-xl flex items-center justify-center`}>
          <Icon className={`w-6 h-6 text-${color}`} />
        </div>
      </div>
      <p className="text-3xl font-bold text-slate-900">{value}</p>
      <p className="text-sm text-slate-500 mt-1">{label}</p>
    </div>
  );

  const NavCard = ({ to, icon: Icon, title, description }) => {
    return (
      <Link to={to} className="bg-white rounded-2xl border border-slate-100 p-6 hover:border-primary transition-colors group">
        <Icon className="w-8 h-8 text-primary mb-3" />
        <h3 className="font-semibold text-slate-900 group-hover:text-primary flex items-center gap-1">
          {title}
          <ChevronRight className="w-4 h-4 opacity-0 group-hover:opacity-100 transition-opacity" />
        </h3>
        <p className="text-sm text-slate-500">{description}</p>
      </Link>
    );
  };

  return (
    <div className="min-h-screen bg-slate-50" data-testid="admin-dashboard">
      <Navbar />

      <div className="container-app py-8">
        <div className="mb-8">
          <h1 className="text-2xl md:text-3xl font-bold text-slate-900 mb-2">Painel Administrativo</h1>
          <p className="text-slate-600">Visão geral da plataforma BuscaDoutor</p>
        </div>

        {/* Stats Grid */}
        {loading ? (
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
            {[1, 2, 3, 4].map((i) => (
              <div key={i} className="animate-pulse h-32 bg-white rounded-2xl"></div>
            ))}
          </div>
        ) : (
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
            <StatCard icon={Users} label="Total de Pacientes" value={stats?.total_patients || 0} />
            <StatCard icon={Stethoscope} label="CNPJs Cadastrados" value={stats?.total_doctors || 0} />
          </div>
        )}

        {/* Navigation Grid */}
        <h2 className="text-lg font-semibold text-slate-900 mb-4">Gerenciamento</h2>
        <div className="grid md:grid-cols-3 lg:grid-cols-4 gap-4 mb-8">
          <NavCard to="/admin/inteligencia" icon={TrendingUp} title="Inteligencia de Mercado" description="Analytics de buscas" />
          <NavCard to="/admin/usuarios" icon={Users} title="Usuarios" description="Gerenciar contas" />
          <NavCard to="/admin/medicos" icon={Stethoscope} title="Base de CNPJ" description="Médicos e clínicas" />
          <NavCard to="/admin/especialidades" icon={Activity} title="Especialidades" description="Configurar especialidades" />
          <NavCard to="/admin/convenios" icon={Shield} title="Convênios" description="Planos de saúde" />
          <NavCard to="/admin/backups" icon={Database} title="Backups" description="Backup da base" />
          <NavCard to="/admin/cidades" icon={MapPin} title="Cidades do Brasil" description="Download de cidades" />
          <NavCard to="/conta/senha" icon={Lock} title="Alterar Senha" description="Trocar a senha do meu usuário admin" />
        </div>
      </div>
    </div>
  );
}
